// extracted by mini-css-extract-plugin
module.exports = {"body__btn__hover":"Button_body__btn__hover__1PNwq","button__header":"Button_button__header__30NYr","button__header_hover":"Button_button__header_hover__2gW6p"};